import { __rest } from "tslib";
import React from 'react';
import { DatePicker as MuiDatePicker, } from '@mui/x-date-pickers';
export function DatePicker(_a) {
    var { className = '', onChange, renderInput, value, dataTestId } = _a, otherDatePickerProps = __rest(_a, ["className", "onChange", "renderInput", "value", "dataTestId"]);
    return (React.createElement(MuiDatePicker, Object.assign({ className: className, onChange: onChange, renderInput: renderInput, value: value, "data-testid": dataTestId }, otherDatePickerProps)));
}
